import { ENTITY_TYPES } from '@sales-center/common'
import React from 'react'
import Box from '@mui/material/Box'
import { Notes } from './Notes'
import { EntityDetail } from '@user/store/map/typings'
import { LocationDTO } from '@sales-center/common'
import { ErrorModalState } from '../../DrawerContentsSingle/hooks/useData'
import { Attachments } from './Attachments'

type Props = {
  entityType: ENTITY_TYPES
  entityDetails: EntityDetail
  canUpdate: boolean
  serviceLocation: LocationDTO
  setErrorModal: (errorModal: ErrorModalState) => void
}

export function ActionButtons(props: Props) {
  const {
    entityType,
    entityDetails,
    canUpdate,
    serviceLocation,
    setErrorModal,
  } = props

  if (entityType === ENTITY_TYPES.DraftLead) return null

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: 2.3,
          mt: 2.4,
        }}
      >
        <Notes
          entityDetails={entityDetails}
          canUpdate={canUpdate}
          serviceLocation={serviceLocation}
          setErrorModal={setErrorModal}
        />
        <Attachments
          entityDetails={entityDetails}
          canUpdate={canUpdate}
          serviceLocation={serviceLocation}
          setErrorModal={setErrorModal}
        />
      </Box>
    </>
  )
}
